export const jaJP = {
   "name": { label: "名前", help: "レコードの一意の名前。" },
   "description": { label: "説明", help: "レコードのより詳細な説明。" },
   "shortName": { label: "短い名前", help: "レコードの一意の短い名前。" },
   "sort": { label: "並べ替え位置", help: "リスト内のレコードのデフォルトの位置。" },
   "workingGroup_name": { help: "ワーキンググループの一意の名前。" },
   "workingGroup_description": { help: "ワーキンググループの目的。" },
   "workingGroup_accessGroupName": { label: "編集権限のグループ", help: "編集権限を付与するために使用されるグループの名前。 " },
   "workingGroup_baseProfileUri": { label: "ベースURI", help: "ワーキンググループによって定義されたすべてのプロファイルのベースURI。" },
};